<script>
  import { Modal } from 'bootstrap';
  import { client } from 'root/api/index.js';
  let taskTemplateModalLabel;
  let modalShown = false;
  export const show = (params) => {
    taskTemplateModalLabel = new Modal(document.getElementById('taskTemplateModal'), {
      keyboard: false,
    });
    taskTemplateModalLabel.show();
    extraFilter.units = [{ unitId: params.unitId, id: params.unitId }];
    extraFilter.clients = params.clients;
    extraFilter.unitProjectId = params.unitProjectId;
    extraFilter.taskType = params.taskType;
    modalShown = true;
  };
  export const hide = () => {
    if (taskTemplateModalLabel != undefined) {
      taskTemplateModalLabel.hide();
    }
  };
  let defaultFilter = {
    searchKeyword: '',
    units: [],
    clients: [],
    taskSubType: 1,
  };

  let extraFilter = { ...defaultFilter };
  let getData = (queries) => {
    return client.taskTemplateSelectList(50, 1, {
      ...queries,
      ...extraFilter,
    });
  };
  let selectedTemplateId;
  export let onSelectTemplate;
  import DataTable from '../DataTable/DataTable.svelte';
  let datatableRef;
  let scrollRef;
  let columns = [
    { key: 'id', label: '', sortable: false },
    { key: 'name', label: 'Task', sortable: false },
    { key: 'description', label: 'Short description', sortable: false },
  ];
  let searchTimeout;
  let filterData = () => {
    if (searchTimeout != undefined) {
      clearTimeout(searchTimeout);
    }
    searchTimeout = setTimeout(() => {
      if (datatableRef != undefined) {
        datatableRef.initializeState();
      }
    }, 250);
  };
  $: extraFilter && filterData();
</script>

<!-- Modal -->
<div
  class="modal fade"
  id="taskTemplateModal"
  tabindex="-1"
  aria-labelledby="taskTemplateModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5
          class="modal-title font-size-14"
          id="exampleModalLabel"
        >
          Choose from Templates
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="search-client-input position-relative">
          <img
            class="position-absolute"
            alt=""
            src="/images/search.svg"
          />
          <input
            class="form-control"
            bind:value={extraFilter.searchKeyword}
            placeholder="Search Task"
            type="text"
          />
        </div>
        {#if extraFilter.taskType == 1}
          <div class="d-flex flex-row mt-2">
            <!-- <div class="me-2">
			<label for="" class="text-nowrap form-label mb-0">
			  Engagement type:
			</label>
		</div> -->
            <div class="form-label mb-0 me-2">
              <div class="radio c-radio">
                <label class="text-nowrap">
                  <input
                    type="radio"
                    checked={extraFilter.taskSubType == 1}
                    on:change={(event) => (extraFilter.taskSubType = 1)}
                  />
                  <span class="check-img-blue" />
                  Ongoing
                </label>
              </div>
            </div>

            <div class="form-label mb-0 me-2">
              <div class="radio c-radio">
                <label class="text-nowrap">
                  <input
                    type="radio"
                    checked={extraFilter.taskSubType == 2}
                    on:change={(event) => (extraFilter.taskSubType = 2)}
                  />
                  <span class="check-img-blue" />
                  Project
                </label>
              </div>
            </div>
            <div class="form-label mb-0 me-2">
              <div class="radio c-radio">
                <label class="text-nowrap">
                  <input
                    type="radio"
                    checked={extraFilter.taskSubType == ''}
                    on:change={(event) => (extraFilter.taskSubType = '')}
                  />
                  <span class="check-img-blue" />
                  All
                </label>
              </div>
            </div>
          </div>
        {/if}
        {#if modalShown}
          <div
            class="page-content table-content template-items-list mt-3 p-0"
            bind:this={scrollRef}
          >
            <DataTable
              bind:this={datatableRef}
              columns={columns}
              scrollRef={scrollRef}
              getData={getData}
              let:row
            >
              <td
                class="text-muted"
                width="30"
              >
                <div class="radio c-radio">
                  <label>
                    <input
                      type="radio"
                      on:change={() => (selectedTemplateId = row.id)}
                      name="live_bidding"
                      value="1"
                    />
                    <span class="check-img"></span>
                  </label>
                </div>
              </td>
              <td
                class="text-muted"
                width="400"><span class="text-break">{row.name}</span></td
              >
              <td
                class="text-muted"
                width="600"><span class="text-break">{row.purpose}</span></td
              >
            </DataTable>
          </div>
        {/if}
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="trans-btn my-0 mx-3 px-4 font-size-12 outline-0 btn-cancel font-size-12"
          data-bs-dismiss="modal">Cancel</button
        >
        <button
          type="button"
          on:click={() => onSelectTemplate(selectedTemplateId)}
          class="btn btn-primary m-0 px-4 font-size-12">Select</button
        >
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  .template-items-list {
    max-height: 400px;
  }
</style>
